import { CREATE_CONTACT_ADD_TO_LIST, CLEAR_ACTIVECAMPAIGN, CREATE_CONTACT_ADD_TO_LIST_FROM_FOOTER} from '../types';

export const createContactAddToList = (name, email) => ({ type: CREATE_CONTACT_ADD_TO_LIST, payload: {name: name, email: email} });

export const clearActiveCampaign = () => ({ type: CLEAR_ACTIVECAMPAIGN });

export const createContactAddToListFromFooter = (name, email) => {
    return { type: CREATE_CONTACT_ADD_TO_LIST_FROM_FOOTER, payload: {name: name, email: email} }
};